module.exports = __webpack_public_path__ + "img/card-green.e97bc9a4.svg";